<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FF4343"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />

    <v-snackbar v-model="showSnackBar" color="red" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center pt-2>
      <v-flex px-2 xs12 sm12 md12 lg12 xl12 text-center>
        <v-card class="mb-1">
          <v-card-title
            >Product Details
            <v-spacer></v-spacer>
            <router-link
              style="text-decoration: none; color: black"
              :to="'/productEdit?product=' + productData._id"
            >
              <v-btn color="red" outlined>Edit Product</v-btn>
            </router-link>
          </v-card-title>
        </v-card>
        <v-card class="mb-1 pb-4">
          <v-layout wrap justify-center fill-height>
            <v-flex xs12 sm12 md5 lg5 xl4 pl-2 pt-2>
              <v-card outlined elevation="0" tile height="80vh">
                <v-layout wrap justify-center fill-height>
                  <v-flex xs12 align-self-center>
                    <span v-if="photos">
                      <v-img
                        v-if="!curImage"
                        :src="baseURL + '/file/get/' + photos[0]"
                        max-height="60vh"
                        contain
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="#0066ff"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-img
                        v-else-if="curImage"
                        :src="baseURL + '/file/get/' + curImage"
                        max-height="60vh"
                        contain
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="#0066ff"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </span>
                    <span v-else>
                      <v-img
                        src="../../assets/logo.png"
                        max-height="60vh"
                        contain
                      >
                      </v-img>
                    </span>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12 sm12 md7 lg7 xl8>
              <v-layout wrap justify-center>
                <v-flex xs11>
                  <v-card tile outlined elevation="0" class="mt-2">
                    <v-layout wrap pa-4 justify-center>
                      <v-flex xs2 v-for="(item, i) in photos" :key="i">
                        <v-card @click="showImage(item)" elevation="0" tile>
                          <v-layout wrap justify-center>
                            <v-flex pa-2>
                              <v-img
                                :src="baseURL + '/file/get/' + item"
                                height="100px"
                                contain
                              >
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                  >
                                    <v-progress-circular
                                      indeterminate
                                      color="#0066ff"
                                    ></v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex xs11 pt-3>
                  <v-layout wrap justify-start>
                    <v-flex xs6 text-left>
                      <span
                        style="
                          font-family: poppins;
                          font-size: 27px;
                          color: #000000;
                        "
                      >
                        {{ productData.name }}
                      </span>
                    </v-flex>
                    <v-flex xs6 text-right v-if="productData.stockQuantity">
                      <span
                        style="
                          font-family: poppins;
                          font-size: 22px;
                          color: #3bc17a;
                        "
                      >
                        <i> Instock</i>
                      </span>
                    </v-flex>
                    <v-flex xs2 text-right v-else>
                      <span
                        style="
                          font-family: poppins;
                          font-size: 22px;
                          color: #fa0000;
                        "
                      >
                        <i> Out of stock</i>
                      </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap justify-center>
                        <v-flex xs6>
                          <v-layout wrap justify-center>
                            <v-flex xs12 text-left>
                              <span
                                v-if="productData.discount"
                                style="
                                  font-family: poppins;
                                  font-size: 27px;
                                  color: #000000;
                                "
                              >
                                Rs. {{ filterValue(offerPrice) }}
                              </span>
                              <span
                                v-else
                                style="
                                  font-family: poppins;
                                  font-size: 27px;
                                  color: #000000;
                                "
                              >
                                Rs. {{ filterValue(productData.price) }}
                              </span>
                            </v-flex>
                            <v-flex xs12 text-left v-if="productData.discount">
                              <span
                                style="
                                  font-family: poppins;
                                  font-size: 16px;
                                  color: grey;
                                "
                              >
                                <strike>
                                  Rs. {{ filterValue(productData.price) }}
                                </strike>
                              </span>

                              <span
                                class="pl-4"
                                style="
                                  font-family: poppinsregular;
                                  font-size: 16px;
                                  color: #3bc17a;
                                "
                              >
                                <b> {{ productData.discount }}% Off </b>
                              </span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs6 text-left align-self-center>
                          <v-layout wrap justify-start align-content-center v-if="ratingData">
                            <v-flex xs2 text-right px-2 align-self-center>
                              <span
                                style="
                                  font-family: poppinsregular;
                                  font-size: 14px;
                                  color: #8f8f8f;
                                "
                                class="caption"
                              >
                                {{ parseInt(ratingData.rating) }}
                              </span>
                            </v-flex>
                            <v-flex xs8 text-left px-2 align-self-center>
                              <v-rating
                                :value="parseInt(ratingData.rating)"
                                color="#FFD341"
                                background-color="#e0e0e0"
                                empty-icon="$ratingFull"
                                half-increments
                                readonly
                                hover
                                small
                              ></v-rating>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <!-- <v-flex xs12 text-left py-4>
                      <span
                        v-for="(item, i) in productData.size"
                        :key="i"
                        class="px-1"
                      >
                        <v-btn
                          small
                          rounded
                          depressed
                          outlined
                          @click="changeSize(item)"
                          :ripple="false"
                          :color="
                            productSize.size == item.size
                              ? '#FF0000'
                              : '#919191'
                          "
                          class="sizebutton px-2"
                        >
                          {{ item.size }}
                        </v-btn>
                      </span>
                    </v-flex> -->

                    <v-flex xs12 text-left>
                      <span
                        v-if="productData.stockQuantity <= 10"
                        style="
                          font-family: poppins;
                          font-size: 16px;
                          color: #ff0000;
                        "
                      >
                        Stock : {{ productData.stockQuantity }} Left
                      </span>
                      <span
                        v-else
                        style="font-family: poppins; font-size: 16px"
                      >
                        Stock : {{ productData.stockQuantity }} Left
                      </span>
                    </v-flex>

                    <!-- <v-flex xs12 text-left pt-2>
                      <v-layout wrap justify-start>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: poppins;
                              font-size: 16px;
                              color: #000000;
                            "
                          >
                            COLOR
                          </span>
                        </v-flex>
                      </v-layout>
                      <v-layout wrap justify-start pt-1>
                        <v-flex
                          xs2
                          sm2
                          md1
                          lg1
                          xl1
                          align-self-center
                          v-for="(item, i) in colors"
                          :key="i"
                          px-2
                        >
                          <v-card
                            outlined
                            
                            rounded="50px"
                            class="colorselector"
                            width="40px"
                          >
                            <v-layout py-2 wrap align-content-center>
                              <v-flex xs12 text-center>
                                <v-avatar :color="item.color" size="15" />
                              </v-flex>
                              <v-flex xs12 style="padding-top: 2px" text-center>
                                <span
                                  style="
                                    font-family: poppinsmedium;
                                    font-size: 12px;
                                    color: #808080;
                                  "
                                  >{{ item.quantity }}</span
                                >
                              </v-flex>
                            </v-layout>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-flex> -->
                    <v-flex
                      xs12
                      text-left
                      class="pt-2"
                      v-if="productData.description"
                    >
                      <v-layout wrap justify-start>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: poppins;
                              font-size: 16px;
                              color: #000000;
                            "
                          >
                            DESCRIPTION
                          </span>
                        </v-flex>
                      </v-layout>
                      <span
                        style="
                          font-family: poppins;
                          font-size: 14px;
                          color: #707070;
                        "
                      >
                        {{ productData.description }}
                      </span>
                    </v-flex>
                    <v-flex
                      xs12
                      text-left
                      class="pt-2"
                      v-if="productData.specification"
                    >
                      <v-layout wrap justify-start>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: poppins;
                              font-size: 16px;
                              color: #000000;
                            "
                          >
                            SPECIFICATION
                          </span>
                        </v-flex>
                      </v-layout>
                      <span
                        style="
                          font-family: poppins;
                          font-size: 14px;
                          color: #707070;
                        "
                      >
                        {{ productData.specification }}
                      </span>
                    </v-flex>
                    <v-flex xs12 text-left class="pt-2">
                      <span style="font-size: 16px; text-transform: none">
                        Category
                      </span>
                    </v-flex>
                    <v-flex xs12 text-left>
                      <!-- v-for="(item, i) in category"
                      :key="i"
                      class="pl-4 ma-2"
                      style="font-size: 14px" -->
                      <v-chip>
                        {{ category.name }}
                      </v-chip>
                    </v-flex>
                    <v-flex xs12 text-left class="pt-2">
                      <span style="font-size: 16px; color: #000000">
                        Sub-Category
                      </span>
                    </v-flex>
                    <v-flex xs12 text-left>
                      <v-chip>
                        {{ subcategory.name }}
                      </v-chip>
                    </v-flex>
                    <v-flex xs12 text-left class="pt-2">
                      <span
                        style="
                          font-weight: bold;
                          font-size: 16px;
                          text-transform: none;
                        "
                      >
                        SELLER
                      </span>
                    </v-flex>
                    <v-flex xs12 text-left>
                      <router-link
                        :to="'/seller/' + productData.sellerId.uid"
                        style="text-decoration: none; color: black"
                      >
                        {{ productData.sellerId.shopName }}
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl10 pt-2>
              <Review v-if="ratingData" v-bind:ratingData="ratingData" v-bind:productData="productData" />
            </v-flex>
            <v-row class="justify-center pt-4" v-if="productData.productStatus != 'pending'">
              <span class="px-2">
                <template>
                  <v-dialog v-model="deletedialog" max-width="600px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-on="on" v-bind="attrs" outlined color="red"
                        >Delete Product</v-btn
                      >
                    </template>
                    <v-card>
                      <v-card-title class="headline grey lighten-2">
                        Delete Confirmation
                      </v-card-title>
                      <v-card-text style="padding-bottom: 0px">
                        <v-col cols="12">
                          <span style="font-size: 16px; font-weight: 600"
                            >Please confirm that you want to Delete this
                            Product?
                          </span>
                        </v-col>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" @click="deletedialog = false"
                          >Cancel</v-btn
                        >
                        <v-btn color="primary" @click="deleteProduct()"
                          >Delete</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </template>
              </span>
            </v-row>
            <v-row
              class="justify-center pt-4"
              v-if="productData.productStatus == 'pending'"
            >
              <span class="px-2">
                <template>
                  <v-dialog v-model="rejectdialog" max-width="600px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-on="on" v-bind="attrs" outlined color="red"
                        >Reject Product</v-btn
                      >
                    </template>
                    <v-card>
                      <v-card-title class="headline grey lighten-2">
                        Delete Confirmation
                      </v-card-title>
                      <v-card-text style="padding-bottom: 0px">
                        <v-col cols="12">
                          <span style="font-size: 16px; font-weight: 600"
                            >Please confirm that you want to Remove this
                            Product?
                          </span>
                          <v-text-field
                            outlined
                            dense
                            v-model="remark"
                            label="Remark"
                          >
                          </v-text-field>
                        </v-col>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" @click="rejectdialog = false"
                          >Cancel</v-btn
                        >
                        <v-btn color="primary" @click="rejectProduct()"
                          >Reject</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </template>
              </span>
              <span v-if="productData.productStatus == 'pending'">
                <v-btn outlined color="primary" @click="approveProduct()"
                  >Approve Product</v-btn
                >
              </span>
               
            </v-row>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import Review from "./Review";
export default {
  //   props: ["productData", "productPhotos"],
  components: {
    Review,
  },
  data() {
    return {
      appLoading: false,
      wishlistLoading: false,
      cartLoading: false,
      showSnackBar: false,
      timeout: 5000,
      remark: "",
      rejectdialog: false,
      deletedialog: false,
      ServerError: false,
      msg: null,
      colors: [
        { color: "#C2C2C2", quantity: 23 },
        { color: "#EE2749", quantity: 87 },
        { color: "#000000", quantity: 12 },
        { color: "#5E0C0C", quantity: 32 },
        { color: "#4251D1", quantity: 241 },
        { color: "#4251D1", quantity: 241 },
      ],
      promoCode: null,
      productSize: {},
      curImage: null,
      productData: {},
      category: {},
      subcategory: {},
      photos: null,
      offerPrice: null,
      ratingData: null,
    };
  },
  beforeMount() {
    this.getProduct();
  },
  methods: {
    filterValue(value) {
      var val = value.toFixed(2);
      return Number(val).toLocaleString();
    },
    showImage(item) {
      this.curImage = item;
    },
    changeSize(item) {
      this.productSize = item;
    },
    getProduct() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/admin/seller/product/view/" + this.$route.params.id,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.productData = response.data.data;
            if (this.productData.discount)
              this.offerPrice =
                this.productData.price * (1 - this.productData.discount / 100);
            this.photos = this.productData.photos;
            if (this.productData.subcategoryId)
              this.subcategory = this.productData.subcategoryId;
            if (this.productData.categoryId)
              this.category = this.productData.categoryId;
            this.getRatings();
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    approveProduct() {
      this.appLoading = true;
      axios({
        url: "/admin/product/approve/reject",
        method: "POST",
        data: {
          id: this.$route.params.id,
          action: "approve",
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Product Approval Complete!";
            this.showSnackBar = true;
            this.$router.go(-1);
            this.getProduct();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    rejectProduct() {
      this.rejectdialog = false;
      this.appLoading = true;
      axios({
        url: "/admin/product/approve/reject",
        method: "POST",
        data: {
          id: this.$route.params.id,
          action: "reject",
          rejectReason: this.remark,
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Product Rejected";
            this.showSnackBar = true;
            this.$router.go(-1);
            this.getProduct();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
      deleteProduct() {
      this.deletedialog = false;
      this.appLoading = true;
      axios({
        url: "/admin/product/delete/" + this.$route.params.id,
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Product Deleted";
            this.showSnackBar = true;
            this.$router.go(-1);
            this.getProduct();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getRatings() {
      this.appLoading = false;
      axios({
        method: "POST",
        url: "/rating/list",
        data: {
          limit: 5,
          page: 1,
          ratingType: "product",
          productId: this.$route.params.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.ratingData = response.data;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.colorselector.v-sheet.v-card {
  border-radius: 35px;
}
.sizebutton.v-btn:not(.v-btn--round).v-size--small {
  /* min-width: 50px; */
  padding: 0 12px !important;
  min-width: 30px !important;
}
</style>